<script lang="ts">import { t, Verbiage } from "@infinitro/content";
import { getIcon } from "../data/icons";
const OriginalsTabIcon = getIcon("OriginalsTabIcon");
export let size = 16;
export let active = false;
export let hover = false;
export let color = undefined;
</script>

{#if typeof OriginalsTabIcon === 'string'}
	<img src={OriginalsTabIcon} alt={$t(Verbiage.icon_alt, 'alts')} />
{:else if typeof OriginalsTabIcon === 'function'}
	<svelte:component this={OriginalsTabIcon} {size} {active} {hover} {color} />
{:else}
	<span>Invalid icon</span>
{/if}

<style>
</style>
